export const LISTENING_DIFFICULTY_THRESHOLDS = [1.75, 2.25, 2.75, 3.25] as const;
